import { useEffect } from "react"
import BookingWizardPage from "@/pages/BookingWizard"
import { useBookingStore } from "@/store/booking-store"

export default function BookingSchedulePage() {
  const { setBookingState } = useBookingStore()

  useEffect(() => {
    setBookingState({ bookingStep: "schedule" })
  }, [setBookingState])

  return <BookingWizardPage />
}
